module.exports = __webpack_public_path__ + "static/media/receita.8b0a82f5.png";